import { pickBy } from 'lodash';
import { useSessionStorage } from 'usehooks-ts';

import { Json, Literal } from '../types';

const SETTINGS_ALLOWED_KEYS = ['sidebar.left.open', 'sidebar.right.open'];
const SETTINGS_ALLOWED_PREFIXES = ['conversation.chat.settings'];

export const useSessionSetting = <T extends Literal | Json>(
  key: string | null,
  defaultValue: T,
) => {
  const [settings, setSettings] = useSessionStorage<{ [key: string]: Literal | Json }>(
    'localSettings',
    {},
  );

  if (key === null) {
    return [defaultValue, () => {}] as const;
  }

  const value = settings[key] ?? defaultValue;
  const setValue = (newValue: T) => {
    setSettings((prev) =>
      pickBy(
        { ...prev, [key]: newValue },
        (_, key) =>
          SETTINGS_ALLOWED_KEYS.includes(key) ||
          SETTINGS_ALLOWED_PREFIXES.some((prefix) => key.startsWith(prefix)),
      ),
    );
  };

  return [value as T, setValue] as const;
};
